import React, { Fragment, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import SleekLoadingIndicator from '../../components/SleekLoadingIndicator';
import RichTextDisplay from '../../components/RichTextDisplay';
import { RICH_TEXT_LAYOUTS } from '../../Constants';

const EndWorkflowSlide = (props) => {
    const { content = {}, onFinish = () => {} } = props;
    const { blocks = [] } = content;

    const history = useHistory();
    useEffect(() => {
        onFinish();
        setTimeout(() => {
            history.push('/home');
        }, 3000);
    }, []);

    const getSlideContent = () => {
        let key;
        let contentToRender;

        return blocks.map((block, index) => {
            if (!block) {
                return null;
            }
            key = block.id || `block-${index}`;
            if (
                !block.layout ||
                block.layout === RICH_TEXT_LAYOUTS.TOP_TEXT_BOTTOM_IMAGE ||
                block.layout === RICH_TEXT_LAYOUTS.TOP_TEXT_ONLY
            ) {
                contentToRender = (
                    <>
                        <div className={'row header-end-slide'}>
                            <RichTextDisplay className={'playerDescription'} htmlToDisplay={block.header || ''} />
                        </div>
                        <div className={'row subheader-end-slide'}>
                            <RichTextDisplay className={'playerDescription'} htmlToDisplay={block.subheader || ''} />
                        </div>
                        <div className={'col-12 row loading-end-slide'}>
                            <SleekLoadingIndicator className={'sleek-loading-indicator_large'} />
                        </div>
                        <div className={'row footer-end-slide'}>
                            <RichTextDisplay className={'playerDescription'} htmlToDisplay={block.footer || ''} />
                        </div>
                    </>
                );
            }
            return <Fragment key={key}>{contentToRender}</Fragment>;
        });
    };

    return <div className={'workspace-slide-header end-workflow-slide row'}>{getSlideContent()}</div>;
};
EndWorkflowSlide.propTypes = {
    content: PropTypes.object,
    onFinish: PropTypes.func.isRequired
};

export default EndWorkflowSlide;
